import { J2Document } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Backdrop, CircularProgress, IconButton, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import { printChartData } from '../../utils/print-chart-data'
import { useParams } from 'react-router-dom'

interface Props {
  title?: string
  dataFetchTimeStamp: string
  printElementId: string
}

/**
 * Allows to print a chart (screenshot) based on it's element id
 */
const PrintChartItem: React.FC<Props> = ({ title, dataFetchTimeStamp, printElementId }) => {
  const { t } = useCustomTranslation()
  const { storageId, installationId } = useParams<{ storageId: string; installationId: string }>()

  const [isDownloading, setIsDownloading] = useState<boolean>(false)

  const handleprintChartData = (): void => {
    printChartData(printElementId, title, installationId, storageId, dataFetchTimeStamp, setIsDownloading, t)
  }

  return (
    <>
      <Tooltip title={t('systemDataHandler.chartHeader.print')}>
        <span>
          <IconButton onClick={handleprintChartData} data-qa={`button-print-chart`} size="large" sx={{ color: 'primary.main' }}>
            <J2Document />
          </IconButton>
        </span>
      </Tooltip>
      <Backdrop open={isDownloading} sx={{ zIndex: 9999 }}>
        <CircularProgress />
      </Backdrop>
    </>
  )
}

export default PrintChartItem
